import Vue from 'vue' //vue配合elementUI消息提示组件使用
/* 定义异步处理方法 action*/
/**
 * import { mapActions } from "vuex";
 * vue组件调用方式：...mapActions(["方法名"])
 * 一般放到vue组件的methods作用域内
 */
export default {
  // 模板
  async FN({ commit }, params) {
    try {
      // const res = await API(params)
      // if (res.code !== 200) return Vue.prototype.$message.error(res.message)
      commit('FN', null) //调用mutations定义的方法
    } catch (error) {
      console.log('action:', error.message)
    }
  },
}
